module.exports = __webpack_public_path__ + "img/res3.0acc8bc2.png";